import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRightIcon, UserGroupIcon, BookOpenIcon, SparklesIcon, AcademicCapIcon } from '@heroicons/react/24/outline';

const Programmes = () => {
  const programmes = [
    {
      id: 'early-years',
      title: 'Early Years',
      subtitle: 'Play-based learning with strong values',
      ageRange: '2.6-4.5 Years',
      description: 'Focused on sensory exploration, early social skills and motor development through play-based activities infused with Islamic manners and values.',
      icon: UserGroupIcon,
      features: [
        'Sensory exploration',
        'Social skills development',
        'Islamic manners',
        'Motor skills',
        'Creative play'
      ],
      image: require('../../assets/update/early-years.png')
    },
    {
      id: 'primary-years',
      title: 'Primary Years',
      subtitle: 'Hifz & Academics in harmony',
      ageRange: '4.6 - 9 Years',
      description: 'Core Cambridge subjects with optional Quranic recitation, building strong foundations in both academic and spiritual learning.',
      icon: BookOpenIcon,
      features: [
        'Cambridge curriculum',
        'Nazra begins',
        'Islamic studies',
        'Character development',
        'Critical thinking'
      ],
      image: require('../../assets/update/primary.png')
    },
    {
      id: 'after-school-activities',
      title: 'School Activities',
      subtitle: 'Robotics, Art, Archery',
      ageRange: 'All Ages',
      description: 'Enriching activities that develop creativity, technical skills, and physical coordination in a fun learning environment.',
      icon: SparklesIcon,
      features: [
        'Robotics programming',
        'Creative arts',
        'Traditional archery',
        'Team building',
        'Skill development'
      ],
      image: require('../../assets/update/activities.png')
    }
  ];

  const levels = [
    {
      title: 'Early Years Foundation',
      ageRange: '2.6 - 4.5 years',
      description: 'Play-based learning with Islamic values',
      features: ['Sensory exploration', 'Social skills', 'Motor development', 'Islamic manners']
    },
    {
      title: 'Primary Education',
      ageRange: '4.6 - 7.5 years',
      description: 'Cambridge curriculum with Quranic studies',
      features: ['Academic excellence', 'Nazra Quran', 'Character building', 'Critical thinking']
    },
    {
      title: 'Key Stage Programs',
      ageRange: '8+ years',
      description: 'Structured British curriculum',
      features: ['Subject specialization', 'Exam preparation', 'University readiness', 'Leadership skills']
    }
  ];

  const enrichmentActivities = [
    {
      title: 'Robotics Activity',
      description: 'Programming and engineering skills',
      icon: '🤖'
    },
    {
      title: 'Art & Crafts',
      description: 'Creative expression and fine motor skills',
      icon: '🎨'
    },
    {
      title: 'Traditional Archery',
      description: 'Focus, discipline, and physical coordination',
      icon: '🏹'
    },
    {
      title: 'Science Experiments',
      description: 'Hands-on learning and discovery',
      icon: '🔬'
    },
    {
      title: 'Sports & Fitness',
      description: 'Physical health and teamwork',
      icon: '⚽'
    }
  ];

  // Scroll functionality commented out since we're centering all 3 cards
  /* const scrollToCard = (index) => {
    if (scrollRef.current) {
      const cardWidth = window.innerWidth < 640 ? 256 : 288; // w-64 on mobile, w-72 on larger screens
      const gap = window.innerWidth < 640 ? 16 : 24; // gap-4 on mobile, gap-6 on larger screens
      const containerWidth = scrollRef.current.offsetWidth;
      const totalCardWidth = cardWidth + gap;

      // Calculate scroll position to show 3 cards and center the selected one
      let scrollPosition;

      if (index === 0) {
        // For first card, scroll to show it as the leftmost of 3 visible cards
        scrollPosition = 0;
      } else if (index === programmes.length - 1) {
        // For last card, position it as the rightmost of 3 visible cards
        const maxScrollLeft = scrollRef.current.scrollWidth - containerWidth;
        scrollPosition = maxScrollLeft;
      } else {
        // For middle cards, center them among the 3 visible cards
        scrollPosition = (totalCardWidth * index) - (containerWidth / 2) + (cardWidth / 2);
      }

      scrollRef.current.scrollTo({
        left: Math.max(0, scrollPosition),
        behavior: 'smooth'
      });
    }
    setActiveIndex(index);
  }; */

  // useEffect for scroll handling commented out since we're centering all 3 cards
  /* useEffect(() => {
    const handleScrollEvent = () => {
      if (scrollRef.current) {
        const scrollLeft = scrollRef.current.scrollLeft;
        const cardWidth = window.innerWidth < 640 ? 256 : 288; // w-64 on mobile, w-72 on larger screens
        const gap = window.innerWidth < 640 ? 16 : 24;
        const totalCardWidth = cardWidth + gap;
        const containerWidth = scrollRef.current.offsetWidth;

        // Calculate which card is most visible in the viewport
        const viewportCenter = scrollLeft + (containerWidth / 2);
        let closestIndex = 0;
        let closestDistance = Infinity;

        for (let index = 0; index < programmes.length; index++) {
          const cardCenter = (totalCardWidth * index) + (cardWidth / 2);
          const distance = Math.abs(viewportCenter - cardCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        }

        setActiveIndex(closestIndex);
      }
    };

    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScrollEvent);

      // Initialize scroll position to show the first card
      const initializeScroll = () => {
        if (scrollRef.current) {
          scrollRef.current.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }
      };

      setTimeout(initializeScroll, 100);
      return () => scrollContainer.removeEventListener('scroll', handleScrollEvent);
    }
  }, [programmes.length]); */

  return (
    <div className="programmes-page">
      {/* Hero Section */}
      <section className="relative flex items-center justify-center min-h-screen overflow-hidden">
        <div
          className="absolute inset-0 transform scale-110 bg-center bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url('${require('../../assets/update/Programmes Hero Image.JPG')}')`
          }}
        />
        <div className="absolute inset-0 bg-black/60" />

        <div className="relative z-10 max-w-4xl px-4 mx-auto text-center text-white">
          <motion.h1
            className="mb-6 text-5xl font-bold md:text-7xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            OUR <span className="text-yellow-400">PROGRAMMES</span>
          </motion.h1>
          <motion.p
            className="mb-8 text-xl text-gray-200 md:text-2xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Comprehensive education that nurtures academic excellence and Islamic values
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex justify-center"
          >
            <Link
              to="/apply-online"
              className="inline-flex items-center justify-center w-full px-8 py-4 text-lg font-semibold text-black transition-colors duration-300 bg-yellow-400 rounded-full sm:w-auto hover:bg-yellow-500 group"
            >
              Apply Now
              <ChevronRightIcon className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Our Programmes Section */}
      <section className="py-20 bg-gray-50">
        <div className="container px-4 mx-auto">
          <div className="mb-16 text-center">
            <h2 className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">
              Our <span className="text-yellow-500">Programmes</span>
            </h2>
            <p className="max-w-3xl mx-auto text-xl text-gray-600">
              Discover our comprehensive educational offerings designed to nurture every child's potential
            </p>
          </div>

          {/* Centered Programme Cards */}
          <div className="relative">
            {/* Left Navigation Arrow - Commented out for centered layout */}
            {/* <button
              onClick={() => scrollToCard(Math.max(0, activeIndex - 1))}
              className={`absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 z-20 bg-white shadow-lg rounded-full p-2 sm:p-3 transition-all duration-300 ${activeIndex === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-yellow-50 hover:shadow-xl'
                }`}
              disabled={activeIndex === 0}
            >
              <svg className="w-4 h-4 text-gray-600 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button> */}

            {/* Right Navigation Arrow - Commented out for centered layout */}
            {/* <button
              onClick={() => scrollToCard(Math.min(programmes.length - 1, activeIndex + 1))}
              className={`absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 z-20 bg-white shadow-lg rounded-full p-2 sm:p-3 transition-all duration-300 ${activeIndex === programmes.length - 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-yellow-50 hover:shadow-xl'
                }`}
              disabled={activeIndex === programmes.length - 1}
            >
              <svg className="w-4 h-4 text-gray-600 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button> */}

            {/* Centered Container - Display all 3 cards */}
            <div className="max-w-6xl py-4 mx-auto sm:py-8">
              <div className="flex flex-col gap-6 px-4 pt-2 pb-4 sm:flex-row sm:justify-center sm:gap-6 sm:pb-8 sm:pt-4 sm:px-8 lg:gap-8">
                {programmes.map((programme, index) => {
                  const Icon = programme.icon;

                  return (
                    <motion.div
                      key={programme.id}
                      className="w-full max-w-sm mx-auto overflow-hidden transition-all duration-300 bg-white shadow-lg cursor-pointer sm:w-64 md:w-72 lg:w-80 rounded-2xl hover:shadow-2xl hover:ring-2 hover:ring-yellow-400 group"
                      whileHover={{ y: -5, scale: 1.02 }}
                      transition={{ duration: 0.2 }}
                    >
                      <div className="relative h-48 overflow-hidden sm:h-48 md:h-52">
                        <img
                          src={programme.image}
                          alt={programme.title}
                          className="object-cover w-full h-full"
                          style={programme.title === "Primary Years" || programme.title === "School Activities" || programme.title === "Qur'an Learning" ? { objectPosition: 'center' } : {}}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                        <div className="absolute text-white bottom-3 left-3">
                          <span className="px-3 py-1 text-sm font-semibold text-black bg-yellow-400 rounded-full">
                            {programme.ageRange}
                          </span>
                        </div>
                      </div>

                      <div className="flex flex-col h-full p-5 sm:p-4">
                        <div className="flex items-center mb-4">
                          <div className="p-2 mr-3 transition-colors duration-300 bg-yellow-100 rounded-lg group-hover:bg-yellow-400">
                            <Icon className="w-5 h-5 text-yellow-600 transition-colors duration-300 sm:h-5 sm:w-5 group-hover:text-black" />
                          </div>
                          <div className="flex-1">
                            <h3 className="text-lg font-bold leading-tight text-gray-900 sm:text-lg">{programme.title}</h3>
                            <p className="text-sm font-medium text-yellow-600 transition-colors duration-300 group-hover:text-yellow-500">{programme.subtitle}</p>
                          </div>
                        </div>

                        <p className="flex-grow mb-4 text-sm leading-relaxed text-gray-600">
                          {programme.description}
                        </p>

                        <div className="mb-5 space-y-2">
                          {programme.features.slice(0, 3).map((feature, idx) => (
                            <div key={idx} className="flex items-center text-sm text-gray-600">
                              <div className="flex-shrink-0 w-2 h-2 mr-3 bg-yellow-400 rounded-full" />
                              {feature}
                            </div>
                          ))}
                        </div>

                        <Link
                          to="/apply-online"
                          className="block w-full py-3 mt-auto text-sm font-semibold text-center text-black transition-all duration-300 transform bg-yellow-400 rounded-lg hover:bg-yellow-500 group-hover:scale-105"
                        >
                          Enroll Now
                        </Link>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>

            {/* Navigation Dots - Commented out for centered layout */}
            {/* <div className="flex justify-center mt-4 space-x-2 sm:mt-4">
              {programmes.map((_, index) => (
                <button
                  key={index}
                  onClick={() => scrollToCard(index)}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-yellow-400 scale-125' : 'bg-gray-300'
                    }`}
                />
              ))}
            </div> */}
          </div>
        </div>
      </section>

      {/* Levels Offered Section */}
      <section className="py-20 bg-white">
        <div className="container px-4 mx-auto">
          <div className="mb-16 text-center">
            <h2 className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">
              Levels <span className="text-yellow-500">Offered</span>
            </h2>
            <p className="max-w-3xl mx-auto text-xl text-gray-600">
              Age-appropriate learning pathways designed for optimal development
            </p>
          </div>

          <div className="grid max-w-6xl grid-cols-1 gap-6 px-4 mx-auto sm:grid-cols-2 md:grid-cols-3 lg:gap-8">
            {levels.map((level, index) => (
              <motion.div
                key={index}
                className="flex flex-col h-full p-6 transition-all duration-300 border border-gray-100 shadow-lg sm:p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl hover:shadow-xl"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="mb-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 mb-4 bg-yellow-100 rounded-full">
                    <AcademicCapIcon className="w-8 h-8 text-yellow-600" />
                  </div>
                  <h3 className="mb-2 text-2xl font-bold text-gray-900">{level.title}</h3>
                  <div className="inline-block px-4 py-1 text-sm font-semibold text-black bg-yellow-400 rounded-full">
                    {level.ageRange}
                  </div>
                </div>

                <p className="flex-grow mb-6 text-center text-gray-600">{level.description}</p>

                <div className="mb-6 space-y-3">
                  {level.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center">
                      <div className="flex-shrink-0 w-2 h-2 mr-3 bg-yellow-400 rounded-full" />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to="/apply-online"
                  className="block w-full py-3 mt-auto font-semibold text-center text-black transition-colors duration-300 bg-yellow-400 rounded-lg hover:bg-yellow-500"
                >
                  Enroll Now
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Co-Curricular Enrichment Section */}
      <section className="py-20 bg-gray-50">
        <div className="container px-4 mx-auto">
          <div className="mb-16 text-center">
            <h2 className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">
              Co-Curricular <span className="text-yellow-500">Enrichment</span>
            </h2>
            <p className="max-w-3xl mx-auto text-xl text-gray-600">
              Beyond academics - developing skills, creativity, and character through engaging activities
            </p>
          </div>

          <div className="grid max-w-5xl grid-cols-1 gap-6 px-4 mx-auto sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            {enrichmentActivities.map((activity, index) => (
              <motion.div
                key={index}
                className="p-6 transition-all duration-300 bg-white shadow-lg sm:p-8 rounded-2xl hover:shadow-xl group"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
              >
                <div className="text-center">
                  <div className="mb-4 text-4xl transition-transform duration-300 sm:text-5xl group-hover:scale-110">
                    {activity.icon}
                  </div>
                  <h3 className="mb-3 text-lg font-bold text-gray-900 sm:text-xl">{activity.title}</h3>
                  <p className="text-sm leading-relaxed text-gray-600 sm:text-base">{activity.description}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center w-full px-8 py-4 text-lg font-semibold text-black transition-colors duration-300 bg-yellow-400 rounded-full sm:w-auto hover:bg-yellow-500 group"
            >
              Schedule a Visit
              <ChevronRightIcon className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Programmes;
